import { Injectable } from "@angular/core";
import type { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { MenuSharedModels, NavigationControlModels } from "@medsurf/flat-models";
import { MenuSharedFacade, PageSharedFacade, SlideViewerFacade } from '@medsurf/flat-facades';
import { validate } from "uuid";

@Injectable({
  providedIn: "root"
})
export class PageSharedResolver implements Resolve<void> {
  constructor(protected pageSharedFacade: PageSharedFacade,
              protected slideViewerFacade: SlideViewerFacade,
              protected menuSharedFacade: MenuSharedFacade) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const idSlug = route.paramMap.get('idSlug');
    const pdfMode = route.queryParamMap.get('pdf');

    if(pdfMode){
      this.menuSharedFacade.requestSetPrintView(pdfMode === 'author' ? MenuSharedModels.ViewerPrintMode.PRINT_AUTHOR : MenuSharedModels.ViewerPrintMode.PRINT_USER);
    }
    
    if (route.data['pathModelType'] !== NavigationControlModels.PathModelType.enum.PAGE) {

      // Load by UUID
      const uuid = idSlug ?? '';
      if (validate(uuid)) {
        return this.slideViewerFacade.requestGetSlideDataByPageId(uuid);
      } 
      
      // Load by Slide Id
      const id = parseInt(idSlug ?? '', 10);
      if (!isNaN(id)) {
        return this.slideViewerFacade.requestGetSlideDataBySlideId(id);
      }
    }
    return this.pageSharedFacade.requestPageByCurrentRoute();
  }
}